import { useCallback } from 'react';

import { fg } from '@confluence/feature-gating';

type UsePreventFirstPublishWithoutApprovalProps = {
	contentId: string | undefined;
	isUnpublishedDraft: boolean;
	spaceKey: string | undefined;
	shouldPreventPublish?: boolean;
};

export const usePreventFirstPublishWithoutApproval = ({
	contentId,
	isUnpublishedDraft,
	spaceKey,
	shouldPreventPublish = false,
}: UsePreventFirstPublishWithoutApprovalProps) =>
	useCallback(async () => {
		if (!fg('confluence_approvals_beta')) {
			return false;
		}

		if (!isUnpublishedDraft || !contentId || !spaceKey) {
			return false;
		}

		return shouldPreventPublish;
	}, [contentId, isUnpublishedDraft, shouldPreventPublish, spaceKey]);
